import React, { useEffect, useState } from 'react'
import Loading from '../../Loading'
import { postConsultarFormasDeLiquidacion, postEliminarFormasDeLiquidacion } from '../../../services/Contratacion'
import ModalConfirmarEliminarFormasDeLiquidacion from './ModalConfirmarEliminarFormasDeLiquidacion'

const ModalEliminarUnaFormaDeliquidacion = ({item,setmodalOndelete,passDataActualizarDataFormasLiquidar}) => {
    const [loading,setloading]=useState(false)
    const [consultarFormasLiquidacion,setconsultarFormasLiquidacion]=useState([])
    const [modalOnMensajeConfirmarEliminarFormasDeLiquidacion, setmodalOnMensajeConfirmarEliminarFormasDeLiquidacion]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOndelete(false)
    }

    useEffect(()=>{
        const body={
            "forLiqCod":item.ForLiqCod            
        }
        setloading(false)
        postConsultarFormasDeLiquidacion(body).then((res)=>{
            setloading(true)
            setconsultarFormasLiquidacion(res.data.data)
        })
    },[])

    const handleOnclicEliminarFormasLiquidar=()=>{
      setmodalOnMensajeConfirmarEliminarFormasDeLiquidacion(true)
  }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-full  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Eliminar formas Liquidación
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form >
              <div className="flex py- text-left">
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Código
                  </label>
                  <div className="flex">
                    <input
                      
                      defaultValue={item.ForLiqCod}
                      disabled={true}
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={item.ForLiqDsc}
                      name="codigoMedico"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    {/* <label className="px-2">Tipo cruento</label>
                    <input
                      
                      name="nombre"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    /> */}
                    
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo cruento
                  </label>
                  <div className="flex">
                  
                  
                  <select          
                    //onChange={handleOnchangeCaracteristica}  
                    defaultValue={item.ForTiCru}
                    disabled={true}        
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='tipoCruento'
                  >
                    <option value="N">Cruento</option>
                    <option value="S">No cruento</option>                    
                  </select>
                
                    {/* <button
                      type="submit"
                      className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button> */}
                  </div>
                </div>
              </div>
              {/* <div className="flex py-2 text-left">
                <div className="w-2/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Tipo cruento
                  </label>
                  <div className="flex">
                    <input
                      
                      name="especialidadMedico"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <button
                      type="submit"
                      className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div> */}
            </form>
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-4 inline-block min-w-full sm:px-6 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                          <th></th>
                          {/* <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Código
                          </th> */}
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Código
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Descripción
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Característica
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Vlr Honorarios
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Factor
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Descripción Del Factor
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                           Liqui?
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Codigo Qx
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            No. Apli. %Base
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          consultarFormasLiquidacion.map((item, index) => (
                            <tr className=" divide-y divide-slate-700 " key={index}>
                              <td></td>
                              {/* <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">        
                                <button
                                            //onClick={handleClickConsentimientoInformado}
                                            type="button"
                                            className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                                            >
                                            Eliminar
                                            </button>
                                </td> */}
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.HnrCod}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                              {item.HnrDsc? item.HnrDsc.trim():null}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                              {item.ForLiqcar === 'U'? 'UVR':null}
                                {item.ForLiqcar === 'R'? 'RANGO':null}
                                {item.ForLiqcar === 'V'? 'VALOR FIJO':null}
                                {item.ForLiqcar === 'T'? 'TIEMPO':null}
                                {item.ForLiqcar === 'A'? 'VALOR VARIABLE':null}
                                {item.ForLiqcar === 'F'? 'FACTOR':null}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.ForLiqVlHn}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.FctoCod}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.FctoDsc}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                              <div className="topping">
                                    <input
                                    type="checkbox"                                    
                                    checked={item.ForInIm === 'S'}                                    
                                    />
                                </div>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.ForCodQx}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                              <div className="topping">
                                    <input
                                    type="checkbox"                                    
                                    checked={item.FOREXCBAS === 'S'}                                    
                                    />
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                              <Loading />
                            </td>
                          </tr>
                        )}
                        
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              onClick={handleOnclicEliminarFormasLiquidar}
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
             Eliminar
            </button>
          </div>
        </div>
      </div>
      {modalOnMensajeConfirmarEliminarFormasDeLiquidacion? <ModalConfirmarEliminarFormasDeLiquidacion setmodalOnMensajeConfirmarEliminarFormasDeLiquidacion={setmodalOnMensajeConfirmarEliminarFormasDeLiquidacion} item={item} setmodalOndelete={setmodalOndelete} passDataActualizarDataFormasLiquidar={passDataActualizarDataFormasLiquidar}/>:null}
    </div>
  )
}

export default ModalEliminarUnaFormaDeliquidacion